"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatRateTarification = void 0;
class FlatRateTarification {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.FlatRateTarification = FlatRateTarification;
(function (FlatRateTarification) {
    FlatRateTarification.FlatRateTypeEnum = {
        Physician: 'physician',
        Physiotherapist: 'physiotherapist',
        Nurse: 'nurse',
        Ptd: 'ptd',
    };
})(FlatRateTarification = exports.FlatRateTarification || (exports.FlatRateTarification = {}));
//# sourceMappingURL=FlatRateTarification.js.map